<mat-tree class="flex-force flex-col navigation-tree" [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-nav-list>
    <!-- Tree children -->
    <mat-tree-node class="navigation-tree-item color-primary-contrast" *matTreeNodeDef="let node" matTreeNodePadding>
      <a mat-list-item color="secondary"
        routerLink="projekte"
        (click)="onClick(node.treeview, node.value)" >
        <span matListItemTitle class="navigation-tree-item-text" [ngClass]="(node.treeview == 'projekte' && appStateService.navigationBereich() == node.value) || (node.treeview == 'bearbeitung' && appStateService.navigationBearbeitung() == node.value) ? 'font-header-bold' : 'font-header'">{{node.name}}</span>
      </a>
    </mat-tree-node>
  </mat-nav-list>
  <!-- Tree parent -->
  <mat-tree-node 
        *matTreeNodeDef="let node; when: hasChild"        
        class="navigation-tree-node color-primary-contrast" 
        matTreeNodePadding>
    <button mat-icon-button matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.name">
      <mat-icon class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    {{node.name}}
  </mat-tree-node>
</mat-tree>